import Vue from "vue";
import Vuex from "vuex";
import ocr from "./modules/ocr";
import ws from "./modules/ws";
import chat from "./modules/chat";
import user from "./modules/user";
import thumb from "./modules/thumb";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        ocr,
        ws,
        chat,
        user,
        thumb
    },
});
